import LoadingMoreArticles from "./LoadingMoreArticles";
import { Button } from '@mui/material';
export default function InfiniteScrollPrompt({ loading = false, onClick = () => {} }) {

  const styles = {
    wrapper: {
      width: "100%",
      padding: "12px 0",
      // background: "#f5f5f5",
      textAlign: "center",
      fontFamily: "system-ui, sans-serif",
      // position: 'absolute',
      bottom: '60px'
    },
    text: {
      fontSize: "1rem",
      fontWeight: 400,
      letterSpacing: "0.5px",
    },
    dot: {
      display: "inline-block",
      marginLeft: 2,
      animation: "pulse 1s infinite ease-in-out",
    },
  };
  return (
    <div style={styles.wrapper}>
      {loading ? <LoadingMoreArticles /> : (
        <Button onClick={onClick}><span style={styles.text}>↓&nbsp; Load More... &nbsp;</span></Button>
      )}
    </div>

  );
}
